import React from "react";
var __jsx = React.createElement;
export default function CornerRibbon(_ref) {
  var ribbon = _ref.ribbon;
  var title = ribbon.titles[0];
  if (!title) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "absolute en:right-[-1px] ar:left-[-1px] top-[-1px] flex h-6 items-center rounded-br-md rounded-tl-md px-2 py-0.5",
    style: {
      backgroundColor: ribbon.bg_color
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[10px] font-semibold leading-none",
    style: {
      color: title.text_color
    }
  }, title.text));
}